import { Directive, ElementRef, OnInit, inject, input, output } from '@angular/core';

@Directive({
  selector: '[sharedInfiniteScroll]',
  standalone: true,
})
export class InfiniteScrollDirective implements OnInit {
  private element = inject(ElementRef);

  scrollLoading = input.required<boolean>();
  hasNextPage = input<boolean>();
  cacheBlockSize = input<number>(50);
  fetchNextPage = output<void>();

  ngOnInit(): void {
    this.initScroll();
  }

  private initScroll(): void {
    if (!this.element.nativeElement) return;
    const container = this.element.nativeElement;

    container.addEventListener('scroll', () => {
      const scrollPosition = container.scrollTop + container.clientHeight;
      const scrollHeight = container.scrollHeight;

      if (scrollHeight - scrollPosition < 100 && !this.scrollLoading() && this.hasNextPage()) this.fetchNextPage.emit();
    });
  }
}
